module.exports = __webpack_public_path__ + "media/2_1-10.c0832a1a.mp3";